import React from 'react';
import ItemLists from '../ItemLists/ItemLists';
import Navbar from '../Navbar/Navbar';
import Sidebar from '../Sidebar/Sidebar';
import './Home.scss';
import DataTable from '../DataTable/DataTable';

function Home() {
    //
    return (
        <div className="home">
            <div className="home_sidebar">
                <Sidebar />
            </div>

            <div className="home_main">
                <Navbar />

                <div className="bg_color" />


                <div className="home_items">
                    <ItemLists type="user" />
                    <ItemLists type="admin" />
                    {/* <ItemLists type="crop" /> */}
                    <ItemLists type="farms" />
                </div>

                {/* <div className="chart_sec">
                    <ProgressBar />
                    <Chart height={450} title="Revenue" />
                </div> */}

                <div className="table">
                    <div className="title">Users List</div>
                    <DataTable />
                </div>
            </div>
        </div>
    );
}

export default Home;
